<div class="row">
    <div class="col-sm-9">
      <div class="booking_ht">
        <sm-title-bar pageTitle="Tasks completed" [showBackToDashboard]="true"></sm-title-bar>
      </div>
    </div>
    <div class="col-sm-3">
    </div>
  </div>
  <div class="row" *ngIf="!loader && todaysBookingData.length>0">
    <div class="col-md-6 col-sm-6 col-12 today_booking_t" *ngFor="let data  of todaysBookingData" (click)="bookingDetails(data)">
      <mat-card >
      <div class="plan-card">
        <!-- <button mat-icon-button [matMenuTriggerFor]="data.data_type == 1 ? menu2 : membersMenu" class="more-button"
          aria-label="More options" style="position: absolute; right: 15px; top: 20px;">
          <mat-icon>more_vert</mat-icon>
        </button> -->
      <mat-menu #menu2="matMenu">
          <!-- <button mat-menu-item (click)="confirmBooking(data)"
            *ngIf="(((data.appointment_status == 0 || data.appointment_status == 1 || data.appointment_status == 2) && (data.customer_hash && data.customer_hash != 'null')))">
            <mat-icon class="material-icons-outlined">check_circle</mat-icon>
            <span>Confirm booking</span>
          </button> -->
          <button mat-menu-item (click)="bookingDetails(data)">
            <mat-icon class="material-icons-outlined">info</mat-icon>
            <span>Booking details</span>
          </button>
          <!-- <button mat-menu-item (click)="cancelBooking(data)"
            *ngIf="(((data.appointment_status == 0 || data.appointment_status == 1 || data.appointment_status == 2 || data.appointment_status == 5)&& data.is_owner == 1))">
            <mat-icon class="material-icons-outlined">cancel</mat-icon>
            <span>Cancel booking</span>
          </button> -->
          <!-- <button mat-menu-item *ngIf="(!data.customer_hash || data.customer_hash == 'null')&& data.is_owner == 1"
            (click)="deleteBooking(data)">
            <mat-icon class="material-icons-outlined">delete</mat-icon>
            <span>Delete booking</span>
          </button> -->
        </mat-menu>
        <mat-menu #membersMenu="matMenu">
          <button mat-menu-item (click)="viewDetailsForMember(data)">
            <mat-icon class="material-icons-outlined">info</mat-icon>
            <span>View details</span>
            </button>
            <!-- <button mat-menu-item (click)="changeAttendanceStatus(1,data)" *ngIf="data.appointment_status == 0 || data.appointment_status == null || data.appointment_status == 'null'">
            <mat-icon class="material-icons-outlined">check_circle</mat-icon>
            <span>mark as present</span>
            </button>
            <button mat-menu-item (click)="changeAttendanceStatus(0,data)" *ngIf="data.appointment_status == 1 || data.appointment_status == null || data.appointment_status == 'null'">
            <mat-icon class="material-icons-outlined">cancel</mat-icon>
            <span>mark as absent</span>
            </button> -->
            <!-- <button mat-menu-item *ngIf="data.appointment_status == 0 || data.appointment_status == 1" (click)="deleteAttendance(data)">
            <mat-icon class="material-icons-outlined">cancel</mat-icon>
            <span>Delete attendance</span>
            </button> -->
            
        </mat-menu>
        <div class="today_list_booking">
          <div class="today_card_img" style="position: relative; flex-shrink: 0;">
  
            <!-- For bookings -->
            <mat-icon
            *ngIf="(!data.customer_thumb_image || data.customer_thumb_image == 'null') && data.data_type == 1"
            [class.new-booking]="(data.appointment_status == 0 ||data.appointment_status == 1 || data.appointment_status == 2) && data.data_type == 1" [class.under-process]="(data.appointment_status == 3 || data.appointment_status == 7 || data.appointment_status == 9)&& data.data_type == 1" [class.completed]="data.appointment_status == 4 && data.data_type == 1" [class.cancelled]="(data.appointment_status == 6 || data.appointment_status == 8)&& data.data_type == 1" [class.confirmed]="data.appointment_status == 5 && data.data_type == 1"
  
  
         
  
  
  
               class="status-icon"></mat-icon>
            <mat-icon
            *ngIf="data.customer_thumb_image && data.customer_thumb_image != 'null' && data.data_type == 1"
            [class.new-booking]="(data.appointment_status == 0 ||data.appointment_status == 1 || data.appointment_status == 2) && data.data_type == 1" [class.under-process]="(data.appointment_status == 3 || data.appointment_status == 7 || data.appointment_status == 9)&& data.data_type == 1" [class.completed]="data.appointment_status == 4 && data.data_type == 1" [class.cancelled]="(data.appointment_status == 6 || data.appointment_status == 8)&& data.data_type == 1" [class.confirmed]="data.appointment_status == 5 && data.data_type == 1"
  
            
  
               class="status-icon"></mat-icon>
  
            <!-- For membership -->
               
            <mat-icon
            *ngIf="(!data.customer_thumb_image || data.customer_thumb_image == 'null') && data.data_type == 2"
            [class.cancelled]="(data.appointment_status == 0 )&& data.data_type == 2"
            [class.new-booking]="(data.appointment_status == 1 && !data.session_status ) && data.data_type == 2"
            [class.under-process]="(data.appointment_status == 1 && (data.session_status ==  2 || data.session_status ==  1)) && data.data_type == 2"
            
            [class.completed]="(data.appointment_status == 1 && data.session_status ==  3) && data.data_type == 2"
  
  
         
  
  
  
               class="status-icon"></mat-icon>
            <mat-icon
            *ngIf="data.customer_thumb_image && data.customer_thumb_image != 'null' && data.data_type == 2"
            [class.cancelled]="(data.appointment_status == 0 )&& data.data_type == 2"
            [class.new-booking]="(data.appointment_status == 1 && !data.session_status ) && data.data_type == 2"
            [class.under-process]="(data.appointment_status == 1 && (data.session_status ==  2 || data.session_status ==  1)) && data.data_type == 2"
            [class.completed]="(data.appointment_status == 1 && data.session_status ==  3) && data.data_type == 2"
  
            
  
               class="status-icon"></mat-icon>
  
  
  
            <div class="booking-initial" *ngIf="!data.customer_thumb_image || data.customer_thumb_image == 'null'">{{data.customer_name.slice(0,1)}}</div>
            <img class="booking-initial-img img-fluid rounded-circle" [src]="data.customer_thumb_image" alt="" *ngIf="data.customer_thumb_image && data.customer_thumb_image != 'null'" onerror="this.src='../../../../assets/images/user-avatar.svg'">
          </div>
          <div class="m-2 tbooking">
            <h2 class="plan-title"> {{ data.customer_name }}</h2>
            <p class="booking-number">  <span class="bookingstar"> {{data.time}}</span> <span *ngIf="data.data_type == 1 && data.appointment_no"><span style="color: #333;">,</span> #{{data.appointment_no}} </span></p>
          </div>
        </div>
        <div class="mobiler_ad">
          <p> {{data.phone}}, {{ data.bookingType }}</p>
        </div>
      
        <p class="plan-cost my-2">
          {{ data.business_name }}
        </p>
        <p class="address_ph my-2">
          {{ data.business_address | ellipsify:45
          }} 
        </p>
        <p class="address_ph my-2">
          <span class="bookingstatus" *ngIf="data.bookingStat && data.bookingStat != '---'"><span class="label">Status: </span> {{data.bookingStat}}</span> 
          <span class="label" *ngIf="data.paymentStat && data.paymentStat != '---'">, Payment: </span> <span class="value"  *ngIf="data.paymentStat && data.paymentStat != '---'">{{data.paymentStat}}</span>
        </p>
        <p class="plan-cost">
          <span class="addign">Assigned to: </span><span class="addign"> {{ data.employee_name }} </span>
        </p>
      </div>

        <div class="arrow_iocn_x">
    <mat-icon>arrow_forward</mat-icon>
  </div>
    </mat-card>
    </div>
  </div>


    <!-- placeholder section start -->
  <div class="common_placeholder" *ngIf="!loader && todaysBookingData.length==0">
      <div class="loading_invoice" style="padding: 50px 0px; text-align: center;">
        <div class="task_addedrt">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 64 64" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M2.652 58.71A3.294 3.294 0 0 0 5.942 62h40.76a3.294 3.294 0 0 0 3.29-3.29V51a1 1 0 0 0-2 0v7.71c0 .711-.579 1.29-1.29 1.29H5.942c-.711 0-1.29-.579-1.29-1.29V9.81c0-.722.579-1.31 1.29-1.31h9.46v1.933a2.59 2.59 0 0 0 2.594 2.579h16.682a2.582 2.582 0 0 0 2.579-2.579V8.5h9.445c.711 0 1.29.588 1.29 1.31v9.783a1 1 0 0 0 2 0V9.81c0-1.825-1.476-3.31-3.29-3.31h-9.483c-.181-1.253-1.246-2.221-2.541-2.221h-4.745A3.999 3.999 0 0 0 26.336 2a3.938 3.938 0 0 0-3.6 2.279h-4.741A2.589 2.589 0 0 0 15.439 6.5H5.942c-1.814 0-3.29 1.485-3.29 3.31zm14.75-51.837c0-.328.266-.594.594-.594h5.452a1 1 0 0 0 .975-.778c.201-.883.988-1.5 1.914-1.5.912 0 1.717.631 1.915 1.5a1 1 0 0 0 .975.778h5.452a.58.58 0 0 1 .579.594v.603c0 .009-.005.016-.005.024s.005.016.005.024v2.908a.58.58 0 0 1-.579.579H17.996a.594.594 0 0 1-.594-.579v-3.56z" fill="#929292" opacity="1" data-original="#000000" class=""></path><path d="M18.803 18.522a.999.999 0 0 0-1.414 0l-2.625 2.625-1.697-1.697a.999.999 0 1 0-1.414 1.414l2.404 2.404a.997.997 0 0 0 1.414 0l3.333-3.333a.999.999 0 0 0 0-1.414zM41.285 18.778a1 1 0 0 0-1-1H23.669a1 1 0 0 0 0 2h16.615a1 1 0 0 0 1-1zM37.877 23.013a1 1 0 0 0-1-1H23.669a1 1 0 0 0 0 2h13.208a1 1 0 0 0 1-1zM18.803 28.411a.999.999 0 0 0-1.414 0l-2.625 2.625-1.697-1.698a.999.999 0 1 0-1.414 1.414l2.404 2.405a1 1 0 0 0 1.414 0l3.333-3.333a.999.999 0 0 0 0-1.414zM18.803 38.3a.999.999 0 0 0-1.414 0l-2.625 2.625-1.697-1.697a.999.999 0 1 0-1.414 1.414l2.404 2.404a.997.997 0 0 0 1.414 0l3.333-3.333a.999.999 0 0 0 0-1.414zM32.951 27.667h-9.282a1 1 0 0 0 0 2h9.282a1 1 0 0 0 0-2zM23.669 33.902h7.485a1 1 0 0 0 0-2h-7.485a1 1 0 0 0 0 2zM23.669 39.556h7.485a1 1 0 0 0 0-2h-7.485a1 1 0 0 0 0 2zM23.669 43.791h9.282a1 1 0 0 0 0-2h-9.282a1 1 0 0 0 0 2zM17.389 48.189l-2.625 2.625-1.697-1.698a.999.999 0 1 0-1.414 1.414l2.404 2.405a1 1 0 0 0 1.414 0l3.333-3.333a.999.999 0 1 0-1.414-1.414zM36.877 47.444H23.669a1 1 0 0 0 0 2h13.208a1 1 0 0 0 0-2zM22.669 52.68a1 1 0 0 0 1 1h16.615a1 1 0 0 0 0-2H23.669a1 1 0 0 0-1 1zM47.898 22.013c-7.417 0-13.451 6.034-13.451 13.45s6.034 13.451 13.451 13.451 13.45-6.034 13.45-13.451-6.034-13.45-13.45-13.45zm0 24.901c-6.314 0-11.451-5.137-11.451-11.451s5.137-11.45 11.451-11.45 11.45 5.137 11.45 11.45-5.137 11.451-11.45 11.451z" fill="#929292" opacity="1" data-original="#000000" class=""></path><path d="m51.972 31.639-5.528 5.528-2.62-2.62a.999.999 0 1 0-1.414 1.414l3.327 3.327a1 1 0 0 0 1.414 0l6.235-6.235a.999.999 0 1 0-1.414-1.414z" fill="#929292" opacity="1" data-original="#000000" class=""></path></g></svg>
        </div>
        <p>No Tasks Complate</p>
    </div>
</div>